











import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { UserAdviserDetailsMeta } from './model/UserAdviserDetailsMeta'
import PersonalItemsIssuedMeta from './model/PersonalItemsIssuedMeta'

const userStore = namespace('UserStore')

@Component({
  components: {
    AppForm
  }
})
export default class ThePersonalItems extends Vue {
  @userStore.State
  private userAdviserDetails!: UserAdviserDetailsMeta

  get currentUser () {
    return this.$store.getters.currentUser
  }

  get isOpsStaff () {
    return this.currentUser.systemrole === 'ops-staff'
  }

  get personalItemsIssued () {
    return this.userAdviserDetails.personalItemsIssued
  }

  get personalItemsStructure (): FormStructure<PersonalItemsIssuedMeta> {
    return [
      {
        label: 'Access Card No.',
        key: 'accessCardNumber',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Locker No.',
        key: 'lockerNumber',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Pigeon Box No.',
        key: 'pigeonBoxNumber',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Security Level',
        key: 'securityLevel',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Pedestal No.',
        key: 'pedestalNumber',
        disabled: !this.isOpsStaff
      },
      {
        label: 'Remarks',
        key: 'remarks',
        type: 'textarea',
        classes: ['colspan'],
        disabled: !this.isOpsStaff
      }
    ]
  }
}
